interface FooterSmallTranslationModel {
    customerServiceHotline: string;
    openingHours: string;
}

const defaultFooterSmallTranslation: Required<FooterSmallTranslationModel> = {
    customerServiceHotline: 'Infolinia',
    openingHours: 'poniedziałek - piątek, {{value}} - {{value2}}',
};

export { type FooterSmallTranslationModel, defaultFooterSmallTranslation };
